import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const fragment = window.location.hash || "";
    const match = fragment.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      nav("/login?error=missing_session", { replace: true });
      return;
    }

    (async () => {
      try {
        const headers = { "X-Session-ID": sessionId };
        const ref = localStorage.getItem("gp_ref");
        if (ref) headers["X-Referral-Code"] = ref;
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers,
          credentials: "include",
        });
        if (!res.ok) throw new Error("Session exchange failed");
        localStorage.removeItem("gp_ref");
        const data = await res.json();
        setUser(data.user);
        // Clean URL and go to dashboard
        window.history.replaceState({}, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/login?error=auth_failed", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-cream-100">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-coral-300 mx-auto" />
        <p className="mt-4 text-navy-700/70">Finishing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
